<template>
    <Tooltip v-if="ac > 0" placement="top"
             :content="`Possui ${ac} ticket${ac > 1 ? 's' : '' } associado${ac > 1 ? 's' : ''}`">
        <Icon type="ios-link" :style="{fontSize: '22px', color: '#515a73'}"></Icon>
    </Tooltip>
</template>

<script>
    export default {
        name: "pgd-associacoes",
        props: ["ac"]
    };
</script>
